import { z } from 'zod';

export const InputSchema = z.object({
    contactPreferences: z.array(z.enum(['email','sms','phone','whatsApp']))
});

export type ChangeContactPreferencesInput = z.infer<typeof InputSchema>;



